export const matchingAnchor = (anchors, hash) => {
  const candidate = hash.replace(/^#/, "")
  return anchors.includes(candidate) ? candidate : anchors[0]
}

export const adjacentAnchor = (anchors, current, direction) => {
  const index = anchors.indexOf(current)
  if (index === -1) return anchors[0]
  return anchors[(index + direction + anchors.length) % anchors.length]
}
